import defaults from './defaults.json';

export default defaults;
